// src/client/super/StaffRoles.tsx
import { useNavigate } from "react-router-dom";
import HomeButton from "../components/HomeButton";

export default function StaffRoles() {
  const nav = useNavigate();

  return (
    <div className="ui-card p-6">
      <header className="mb-5 flex items-center justify-between">
        <h2 className="text-[28px] font-extrabold">Роли и доступы</h2>
        <span className="rounded-full border border-white/15 bg-white/10 px-3 py-1 text-[11px] text-white/90">v1.0</span>
      </header>

      <div className="space-y-4">
        <p className="text-neutral-300 text-sm">
          Здесь можно будет управлять правами доступа: назначать, изменять и снимать роли
          у сотрудников.
        </p>

        <div className="mt-6 flex gap-3">
          <HomeButton />
          <button
            onClick={() => nav("/super")}
            className="ui-btn"
          >
            Назад
          </button>
        </div>
      </div>
    </div>
  );
}
